import axios from "axios";
import { config } from "@/config/constants.js";
import jsonToFormData from "@ajoelp/json-to-formdata";

export default {
  namespaced: true,
  state: {
    endpoint: "",
    status: "",
    selected_rows: [],
    header: [
      { text: "ID", value: "id" },
      { text: "Name", value: "name" },
      { text: "Actions", value: "actions", sortable: false }
    ],
    list: [],
    page: 1,
    total: 0,
    options: {
      itemsPerPage: 10,
      search: "",
      company_id: null,
      store_id: null,
      region_id: null
    }
  },
  mutations: {
    request(state) {
      state.status = "loading";
    },
    success(state, data) {
      state.status = "success";

      if (data && data["list"]) {
        state.list = data["list"];
      }

      if (data && data["total"] >= 0) {
        state.total = data["total"];
      }
    },
    error(state) {
      state.status = "error";
    },
    options(state, data) {
      state.options = data;
    },
    reset_pagination(state) {
      state.list = [];
      state.total = 0;
      state.page = 1;
    }
  },
  actions: {
    getList({ commit, state }, options) {
      return new Promise((resolve, reject) => {
        commit("request");

        let filter = {
          search: "",
          limit: 10,
          page: 1
        };

        if (options) {
          for (let i in options) {
            filter[i] = options[i];
          }

          commit("options", options);
          filter["limit"] = options.itemsPerPage;
          filter["page"] = options.page;
          filter["search"] = options.search;
          filter["sorting_column"] =
              options.sortBy && options.sortBy.length > 0 ? options.sortBy[0] : "";
          filter["sorting_order"] =
              options.sortDesc && options.sortDesc.length > 0
              ? options.sortDesc[0]
                ? "asc"
                : "desc"
              : "";
        }

        axios
          .get(config.api_url + state.endpoint, { params: filter })
          .then(response => {
            commit("success", {
              list: response.data,
              total: parseInt(response.headers["pagination-count"])
            });
            resolve(response.data);
          })
          .catch(err => {
            commit("error");
            reject(err);
          });
      });
    },
    getListAll({ commit, state }, options) {
      return new Promise((resolve, reject) => {
        commit("request");

        let filter = {
          search: "",
          ...options
        };
        if(options && options.limit) filter["limit"] = options.limit === -1 ? state.total : options.limit;
        axios
          .get(config.api_url + state.endpoint, { params: filter })
          .then(response => {
            commit("success", {
              list: response.data,
              total: parseInt(response.headers["pagination-count"])
            });
            resolve(response.data);
          })
          .catch(err => {
            commit("error");
            reject(err);
          });
      });
    },
    create({ commit, state }, data) {
      let saveData = {};
      saveData[state.object] = data;
      return new Promise((resolve, reject) => {
        commit("request");
        const formData = jsonToFormData(saveData, {
          arrayIndexes: true,
          excludeNull: true
        });
        axios
          .post(config.api_url + state.endpoint, formData)
          .then(response => {
            commit("success");
            resolve(response.data);
          })
          .catch(error => {
            console.log(error);
            commit("error");
            reject(error.response.data);
          });
      });
    },
    update({ commit, state }, data) {
      let saveData = {};
      saveData[state.object] = data;
      return new Promise((resolve, reject) => {
        commit("request");
        const formData = jsonToFormData(saveData, {
          arrayIndexes: true,
          excludeNull: true
        });
        axios
          .put(config.api_url + state.endpoint + "/" + data.id, formData)
          .then(response => {
            commit("success");
            resolve(response.data);
          })
          .catch(error => {
            console.log(error);
            commit("error");
            reject(error.response.data);
          });
      });
    },
    delete({ commit, state }, data) {
      return new Promise((resolve, reject) => {
        commit("request");
        axios
          .delete(config.api_url + state.endpoint + "/" + data.id)
          .then(() => {
            commit("success");
            resolve();
          })
          .catch(error => {
            console.log(error);
            commit("error");
            reject(error.response.data);
          });
      });
    },
    show({ commit, state }, id) {
      return new Promise((resolve, reject) => {
        commit("request");
        axios
          .get(config.api_url + state.endpoint + "/" + id)
          .then(response => {
            commit("success");
            resolve(response.data[state.object]);
          })
          .catch(err => {
            console.log(err);
            commit("auth_error");
            reject(err);
          });
      });
    },
    resetInitialPagination({ commit }) {
      commit("reset_pagination");
    }
  },
  getters: {
    status(state) {
      return state.status;
    }
  },
  modules: {}
};
